
Vue.filter("formatOnlyDate", function (value) {
    if (value) {
        return moment(String(value)).format("DD/MM/yyyy");
    }
});


Vue.filter("formatOnlyTime", function (value) {
    if (value) {
        return moment(String(value)).format("HH:mm");
    }
});